var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c("MonthPickerDialog", {
        attrs: { viewModel: _vm.startDateMonthPicker },
        on: { "update-date": _vm.handleUpdateProjectScenarioStartDateCommand },
      }),
      _vm._v(" "),
      _c("MonthPickerDialog", {
        attrs: { viewModel: _vm.minStartDateMonthPicker },
        on: {
          "update-date": _vm.handleUpdateProjectScenarioMinStartDateCommand,
        },
      }),
      _vm._v(" "),
      _c("MonthPickerDialog", {
        attrs: { viewModel: _vm.maxStartDateMonthPicker },
        on: {
          "update-date": _vm.handleUpdateProjectScenarioMaxStartDateCommand,
        },
      }),
      _vm._v(" "),
      _c("MonthPickerDialog", {
        attrs: { viewModel: _vm.commitmentDateMonthPicker },
        on: {
          "update-date": _vm.handleUpdateProjectScenarioCommitmentDateCommand,
        },
      }),
      _vm._v(" "),
      _c("AddProjectsDialog", {
        attrs: { viewModel: _vm.addProjectsDialog },
        on: { "selection-confirmed": _vm.handleAddProjectsToScenarioCommand },
      }),
      _vm._v(" "),
      _c("ProjectPlanPickerDialog", {
        attrs: { viewModel: _vm.projectPlanPickerDialog },
        on: { confirmed: _vm.handleUpdateProjectScenarioPlanLockCommand },
      }),
      _vm._v(" "),
      _c("PortfolioNavigation", {
        attrs: { workspaceId: _vm.workspaceId, projectId: _vm.tchProjectId },
      }),
      _vm._v(" "),
      _vm.rm
        ? _c(
            "div",
            {
              staticClass: "container-fluid",
              staticStyle: { "margin-top": "80px", "padding-top": "20px" },
            },
            [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-lg-6" }, [
                  _c("small", { staticClass: "text-muted" }, [
                    _vm._v(
                      _vm._s(_vm.rm.PortfolioName) +
                        " / " +
                        _vm._s(_vm.rm.ScenarioName)
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "h1",
                    {
                      staticStyle: {
                        "font-size": "2em",
                        "font-weight": "300",
                        color: "#33475b",
                        margin: "0",
                      },
                    },
                    [_vm._v("Plan: Projects")]
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "col-lg-6 d-flex flex-column justify-content-end",
                  },
                  [
                    _c("PortfolioScenarioNavigation", {
                      attrs: {
                        portfolioId: _vm.rm.PortfolioId,
                        corporateScenarioUrl: _vm.rm.CorporateScenarioUrl,
                      },
                    }),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c("hr"),
              _vm._v(" "),
              _c(
                "nav",
                {
                  staticClass: "navbar navbar-light navbar-expand-md mt-5",
                  staticStyle: {
                    "background-color": "rgba(0, 0, 0, 0.03)",
                    border: "1px solid rgba(0, 0, 0, 0.125)",
                    "border-bottom": "0",
                  },
                  attrs: { role: "navigation" },
                },
                [
                  _c("ul", { staticClass: "navbar-nav" }, [
                    _c("li", { staticClass: "dropdown mr-2" }, [
                      _c("div", { staticClass: "navbar-form" }, [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-outline-secondary",
                            attrs: { type: "button" },
                            on: { click: _vm.showAddProjectsDialog },
                          },
                          [
                            _c("i", { staticClass: "fa-solid fa-plus" }),
                            _vm._v(" Add\n                        "),
                          ]
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("li", { staticClass: "dropdown mr-2" }, [
                      _c("div", { staticClass: "navbar-form" }, [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-outline-secondary",
                            attrs: { disabled: _vm.selected.length === 0 },
                            on: {
                              click: function ($event) {
                                return _vm.handleRemoveProjectsFromScenarioCommand(
                                  null
                                )
                              },
                            },
                          },
                          [_c("i", { staticClass: "fa-regular fa-trash-can" })]
                        ),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "btn-group mr-2", attrs: { role: "group" } },
                    [
                      _c("div", { staticClass: "btn-group" }, [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-outline-secondary",
                            attrs: {
                              "data-toggle": "dropdown",
                              disabled: _vm.selected.length === 0,
                            },
                          },
                          [
                            _vm._v(
                              "\n                        Selection\n                    "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "dropdown-menu" }, [
                          _c(
                            "a",
                            {
                              staticClass: "dropdown-item",
                              on: {
                                click: function ($event) {
                                  return _vm.handleUpdateProjectScenarioAcceptanceCommand(
                                    "Accepted",
                                    null
                                  )
                                },
                              },
                            },
                            [_vm._v("Accepted")]
                          ),
                          _vm._v(" "),
                          _c(
                            "a",
                            {
                              staticClass: "dropdown-item",
                              on: {
                                click: function ($event) {
                                  return _vm.handleUpdateProjectScenarioAcceptanceCommand(
                                    "Rejected",
                                    null
                                  )
                                },
                              },
                            },
                            [_vm._v("Rejected")]
                          ),
                          _vm._v(" "),
                          _c(
                            "a",
                            {
                              staticClass: "dropdown-item",
                              on: {
                                click: function ($event) {
                                  return _vm.handleUpdateProjectScenarioAcceptanceCommand(
                                    "TBD",
                                    null
                                  )
                                },
                              },
                            },
                            [_vm._v("TBD")]
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "btn-group",
                          attrs: { title: "Lock / Unlock" },
                        },
                        [
                          _c(
                            "button",
                            {
                              staticClass:
                                "btn btn-outline-secondary custom-rounded-right",
                              attrs: {
                                "data-toggle": "dropdown",
                                disabled: _vm.selected.length === 0,
                              },
                            },
                            [_c("i", { staticClass: "fa-solid fa-lock" })]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "dropdown-menu" }, [
                            _c(
                              "a",
                              {
                                staticClass: "dropdown-item",
                                on: {
                                  click: function ($event) {
                                    return _vm.handleLockProjectScenarioAcceptanceCommand(
                                      null
                                    )
                                  },
                                },
                              },
                              [_vm._v("Lock")]
                            ),
                            _vm._v(" "),
                            _c(
                              "a",
                              {
                                staticClass: "dropdown-item",
                                on: {
                                  click: function ($event) {
                                    return _vm.handleUnlockProjectScenarioAcceptanceCommand(
                                      null
                                    )
                                  },
                                },
                              },
                              [_vm._v("Unlock")]
                            ),
                          ]),
                        ]
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "btn-group mr-2", attrs: { role: "group" } },
                    [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-outline-secondary",
                          attrs: { disabled: _vm.selected.length === 0 },
                          on: {
                            click: function ($event) {
                              return _vm.showCommitmentDateMonthPicker(null)
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n                    Commitment\n                "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "btn-group",
                          attrs: { title: "Lock / Unlock" },
                        },
                        [
                          _c(
                            "button",
                            {
                              staticClass:
                                "btn btn-outline-secondary custom-rounded-right",
                              attrs: {
                                "data-toggle": "dropdown",
                                disabled: _vm.selected.length === 0,
                              },
                            },
                            [_c("i", { staticClass: "fa-solid fa-lock" })]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "dropdown-menu" }, [
                            _c(
                              "a",
                              {
                                staticClass: "dropdown-item",
                                on: {
                                  click: function ($event) {
                                    return _vm.handleLockProjectScenarioCommitmentDateCommand(
                                      null
                                    )
                                  },
                                },
                              },
                              [_vm._v("Lock")]
                            ),
                            _vm._v(" "),
                            _c(
                              "a",
                              {
                                staticClass: "dropdown-item",
                                on: {
                                  click: function ($event) {
                                    return _vm.handleUnlockProjectScenarioCommitmentDateCommand(
                                      null
                                    )
                                  },
                                },
                              },
                              [_vm._v("Unlock")]
                            ),
                          ]),
                        ]
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "btn-group mr-2", attrs: { role: "group" } },
                    [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-outline-secondary",
                          attrs: { disabled: _vm.selected.length === 0 },
                          on: {
                            click: function ($event) {
                              return _vm.showStartDateMonthPicker(null)
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n                    Start date\n                "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "btn-group",
                          attrs: { title: "Lock / Unlock" },
                        },
                        [
                          _c(
                            "button",
                            {
                              staticClass:
                                "btn btn-outline-secondary custom-rounded-right",
                              attrs: {
                                "data-toggle": "dropdown",
                                disabled: _vm.selected.length === 0,
                              },
                            },
                            [_c("i", { staticClass: "fa-solid fa-lock" })]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "dropdown-menu" }, [
                            _c(
                              "a",
                              {
                                staticClass: "dropdown-item",
                                on: {
                                  click: function ($event) {
                                    return _vm.handleLockProjectScenarioStartDateCommand(
                                      null
                                    )
                                  },
                                },
                              },
                              [_vm._v("Lock")]
                            ),
                            _vm._v(" "),
                            _c(
                              "a",
                              {
                                staticClass: "dropdown-item",
                                on: {
                                  click: function ($event) {
                                    return _vm.handleUnlockProjectScenarioStartDateCommand(
                                      null
                                    )
                                  },
                                },
                              },
                              [_vm._v("Unlock")]
                            ),
                          ]),
                        ]
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "btn-group mr-2" }, [
                    _c(
                      "button",
                      {
                        staticClass:
                          "btn btn-outline-secondary custom-rounded-right",
                        attrs: {
                          "data-toggle": "dropdown",
                          disabled: _vm.selected.length === 0,
                        },
                      },
                      [
                        _vm._v(
                          "\n                    Start range\n                "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "dropdown-menu" }, [
                      _c(
                        "a",
                        {
                          staticClass: "dropdown-item",
                          on: {
                            click: function ($event) {
                              return _vm.showMinStartDateMonthPicker(null)
                            },
                          },
                        },
                        [_vm._v("Min start date")]
                      ),
                      _vm._v(" "),
                      _c(
                        "a",
                        {
                          staticClass: "dropdown-item",
                          on: {
                            click: function ($event) {
                              return _vm.showMaxStartDateMonthPicker(null)
                            },
                          },
                        },
                        [_vm._v("Max start date")]
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("ul", { staticClass: "navbar-nav ml-auto mr-2" }, [
                    _c("li", { staticClass: "dropdown" }, [
                      _c("div", { staticClass: "navbar-form" }, [
                        _c("div", { staticClass: "btn-group" }, [
                          _c(
                            "button",
                            {
                              staticClass:
                                "btn btn-outline-secondary dropdown-toggle",
                              attrs: { "data-toggle": "dropdown" },
                            },
                            [_vm._v("Filter: " + _vm._s(_vm.filterLabel))]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "dropdown-menu" },
                            [
                              _c(
                                "a",
                                {
                                  staticClass: "dropdown-item",
                                  on: {
                                    click: function ($event) {
                                      return _vm.setFilter(null, null)
                                    },
                                  },
                                },
                                [_vm._v("All")]
                              ),
                              _vm._v(" "),
                              _c("div", { staticClass: "dropdown-divider" }),
                              _vm._v(" "),
                              _c("h6", { staticClass: "dropdown-header" }, [
                                _vm._v("Filter by selection status:"),
                              ]),
                              _vm._v(" "),
                              _c(
                                "a",
                                {
                                  staticClass: "dropdown-item",
                                  on: {
                                    click: function ($event) {
                                      return _vm.setFilter("TBD", null)
                                    },
                                  },
                                },
                                [_vm._v("TBD")]
                              ),
                              _vm._v(" "),
                              _c(
                                "a",
                                {
                                  staticClass: "dropdown-item",
                                  on: {
                                    click: function ($event) {
                                      return _vm.setFilter("Accepted", null)
                                    },
                                  },
                                },
                                [_vm._v("Accepted")]
                              ),
                              _vm._v(" "),
                              _c(
                                "a",
                                {
                                  staticClass: "dropdown-item",
                                  on: {
                                    click: function ($event) {
                                      return _vm.setFilter("Rejected", null)
                                    },
                                  },
                                },
                                [_vm._v("Rejected")]
                              ),
                              _vm._v(" "),
                              _c("div", { staticClass: "dropdown-divider" }),
                              _vm._v(" "),
                              _c("h6", { staticClass: "dropdown-header" }, [
                                _vm._v("Filter by Kanban status:"),
                              ]),
                              _vm._v(" "),
                              _vm._l(_vm.rm.Statuses, function (s) {
                                return _c(
                                  "a",
                                  {
                                    key: s.Id,
                                    staticClass: "dropdown-item",
                                    on: {
                                      click: function ($event) {
                                        return _vm.setFilter(null, s.Name)
                                      },
                                    },
                                  },
                                  [_vm._v(_vm._s(s.Name))]
                                )
                              }),
                            ],
                            2
                          ),
                        ]),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "form",
                    {
                      staticClass: "form-inline my-2 my-lg-0",
                      attrs: { role: "search" },
                    },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.searchPhrase,
                            expression: "searchPhrase",
                          },
                        ],
                        staticClass: "form-control mr-sm-2",
                        attrs: { type: "search", placeholder: "Search" },
                        domProps: { value: _vm.searchPhrase },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.searchPhrase = $event.target.value
                          },
                        },
                      }),
                    ]
                  ),
                ]
              ),
              _vm._v(" "),
              _c("table", { staticClass: "table table-bordered table-hover" }, [
                _c("thead", [
                  _c("tr", [
                    _c(
                      "th",
                      {
                        staticStyle: {
                          width: "40px",
                          "min-width": "40px !important",
                        },
                      },
                      [
                        _c("div", { staticClass: "btn-group" }, [
                          _vm.noneSelected
                            ? _c(
                                "a",
                                {
                                  staticClass: "pointer",
                                  on: { click: _vm.selectAll },
                                },
                                [
                                  _c("i", {
                                    staticClass: "fa-regular fa-square",
                                  }),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.anySelected && !_vm.allSelected
                            ? _c(
                                "a",
                                {
                                  staticClass: "pointer",
                                  on: { click: _vm.unselectAll },
                                },
                                [_c("i", { staticClass: "fa fa-minus-square" })]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.anySelected && _vm.allSelected
                            ? _c(
                                "a",
                                {
                                  staticClass: "pointer",
                                  on: { click: _vm.unselectAll },
                                },
                                [
                                  _c("i", {
                                    staticClass: "fa-solid fa-square-check",
                                  }),
                                ]
                              )
                            : _vm._e(),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _c("th", { staticClass: "text-left" }, [_vm._v("Project")]),
                    _vm._v(" "),
                    _c("th", [_vm._v("P&L")]),
                    _vm._v(" "),
                    _c("th", [_vm._v("Status")]),
                    _vm._v(" "),
                    _c("th", { attrs: { colspan: "2" } }, [
                      _vm._v("Selection"),
                    ]),
                    _vm._v(" "),
                    _c("th", { attrs: { colspan: "2" } }, [
                      _vm._v("Commitment"),
                    ]),
                    _vm._v(" "),
                    _c("th", { attrs: { colspan: "2" } }, [
                      _vm._v("Start date"),
                    ]),
                    _vm._v(" "),
                    _c("th", [_vm._v("Min start date")]),
                    _vm._v(" "),
                    _c("th", [_vm._v("Max start date")]),
                  ]),
                ]),
                _vm._v(" "),
                _c(
                  "tbody",
                  _vm._l(_vm.projectsView, function (a) {
                    return _c("tr", { key: a.Id }, [
                      _c("td", [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: a.UiSelected,
                              expression: "a.UiSelected",
                            },
                          ],
                          attrs: { type: "checkbox" },
                          domProps: {
                            checked: Array.isArray(a.UiSelected)
                              ? _vm._i(a.UiSelected, null) > -1
                              : a.UiSelected,
                          },
                          on: {
                            change: function ($event) {
                              var $$a = a.UiSelected,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = null,
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 &&
                                    _vm.$set(a, "UiSelected", $$a.concat([$$v]))
                                } else {
                                  $$i > -1 &&
                                    _vm.$set(
                                      a,
                                      "UiSelected",
                                      $$a
                                        .slice(0, $$i)
                                        .concat($$a.slice($$i + 1))
                                    )
                                }
                              } else {
                                _vm.$set(a, "UiSelected", $$c)
                              }
                            },
                          },
                        }),
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _c("div", [
                          _c(
                            "a",
                            {
                              directives: [
                                {
                                  name: "sanitizedHref",
                                  rawName: "v-sanitizedHref",
                                  value: `/#/portfolio/alternative/dashboard/${_vm.workspaceId}/${_vm.tchProjectId}/${a.Id}`,
                                  expression:
                                    "`/#/portfolio/alternative/dashboard/${workspaceId}/${tchProjectId}/${a.Id}`",
                                },
                              ],
                              staticClass: "text-primary",
                            },
                            [
                              _vm._v(
                                "\n                                " +
                                  _vm._s(a.Name) +
                                  "\n                            "
                              ),
                            ]
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "d-flex align-items-center mt-1 plan-meta",
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "plan-text" },
                              [
                                a.PlanId
                                  ? [
                                      a.LockedPlanId
                                        ? [
                                            _c(
                                              "a",
                                              {
                                                staticClass:
                                                  "small plan-toggle d-inline-flex align-items-center",
                                                class: "text-locked-plan",
                                                attrs: {
                                                  role: "button",
                                                  title: a.PlanName
                                                    ? `${a.PlanName} (locked)`
                                                    : "Locked plan",
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    $event.preventDefault()
                                                    return _vm.showPlanPicker(a)
                                                  },
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                            " +
                                                    _vm._s(
                                                      a.PlanName ||
                                                        "Unnamed plan"
                                                    ) +
                                                    "\n                                            "
                                                ),
                                                _c("i", {
                                                  staticClass:
                                                    "fa-solid fa-caret-down ml-1 plan-caret",
                                                  attrs: {
                                                    "aria-hidden": "true",
                                                  },
                                                }),
                                              ]
                                            ),
                                          ]
                                        : [
                                            _c(
                                              "a",
                                              {
                                                staticClass:
                                                  "small plan-toggle d-inline-flex align-items-center",
                                                class: a.ActivePlanId
                                                  ? "text-muted"
                                                  : "text-danger",
                                                attrs: {
                                                  role: "button",
                                                  title: a.ActivePlanId
                                                    ? `${
                                                        a.PlanName ||
                                                        "Unnamed plan"
                                                      } (follows Active)`
                                                    : "No Active plan set — click to choose",
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    $event.preventDefault()
                                                    return _vm.showPlanPicker(a)
                                                  },
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                            " +
                                                    _vm._s(
                                                      a.PlanName ||
                                                        "Unnamed plan"
                                                    ) +
                                                    "\n                                            "
                                                ),
                                                _c("i", {
                                                  staticClass:
                                                    "fa-solid fa-caret-down ml-1 plan-caret",
                                                  attrs: {
                                                    "aria-hidden": "true",
                                                  },
                                                }),
                                              ]
                                            ),
                                          ],
                                    ]
                                  : [
                                      _c(
                                        "a",
                                        {
                                          staticClass:
                                            "small text-danger plan-toggle d-inline-flex align-items-center",
                                          attrs: {
                                            role: "button",
                                            title:
                                              "No plan available — click to choose",
                                          },
                                          on: {
                                            click: function ($event) {
                                              $event.preventDefault()
                                              return _vm.showPlanPicker(a)
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                                        No plan\n                                        "
                                          ),
                                          _c("i", {
                                            staticClass:
                                              "fa-solid fa-caret-down ml-1 plan-caret",
                                            attrs: { "aria-hidden": "true" },
                                          }),
                                        ]
                                      ),
                                    ],
                              ],
                              2
                            ),
                          ]
                        ),
                      ]),
                      _vm._v(" "),
                      _c("td", { staticClass: "text-center align-middle" }, [
                        a.PlanId
                          ? _c(
                              "a",
                              {
                                staticClass: "text-primary",
                                attrs: {
                                  href: `/#/q/project/pnl/${_vm.workspaceId}/${_vm.tchProjectId}/${a.Id}/${a.PlanId}`,
                                },
                              },
                              [
                                _vm._v(
                                  "\n                            View\n                        "
                                ),
                              ]
                            )
                          : _c(
                              "a",
                              {
                                staticClass: "text-danger",
                                attrs: {
                                  href: `/#/q/project/summary/${_vm.workspaceId}/${_vm.tchProjectId}/${a.Id}`,
                                },
                              },
                              [
                                _vm._v(
                                  "\n                            NA\n                        "
                                ),
                              ]
                            ),
                      ]),
                      _vm._v(" "),
                      _c("td", { staticClass: "text-center align-middle" }, [
                        _vm._v(
                          "\n                        " +
                            _vm._s(a.KanbanStatus) +
                            "\n                    "
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "td",
                        { staticClass: "text-center align-middle" },
                        [
                          a.AcceptanceLocked === true
                            ? [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(a.Acceptance) +
                                    "\n                        "
                                ),
                              ]
                            : _vm._e(),
                          _vm._v(" "),
                          a.AcceptanceLocked === false
                            ? [
                                _c("div", { staticClass: "btn-group" }, [
                                  _c(
                                    "a",
                                    {
                                      staticClass:
                                        "text-primary dropdown-toggle",
                                      attrs: { "data-toggle": "dropdown" },
                                    },
                                    [
                                      _vm._v(
                                        "\n                                    " +
                                          _vm._s(a.Acceptance) +
                                          "\n                                "
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "dropdown-menu" }, [
                                    _c(
                                      "a",
                                      {
                                        staticClass: "dropdown-item",
                                        on: {
                                          click: function ($event) {
                                            return _vm.handleUpdateProjectScenarioAcceptanceCommand(
                                              "Accepted",
                                              a.Id
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v("Accepted")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "a",
                                      {
                                        staticClass: "dropdown-item",
                                        on: {
                                          click: function ($event) {
                                            return _vm.handleUpdateProjectScenarioAcceptanceCommand(
                                              "Rejected",
                                              a.Id
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v("Rejected")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "a",
                                      {
                                        staticClass: "dropdown-item",
                                        on: {
                                          click: function ($event) {
                                            return _vm.handleUpdateProjectScenarioAcceptanceCommand(
                                              "TBD",
                                              a.Id
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v("TBD")]
                                    ),
                                  ]),
                                ]),
                              ]
                            : _vm._e(),
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c(
                        "td",
                        {
                          staticClass: "text-center align-middle",
                          staticStyle: { width: "40px" },
                        },
                        [
                          a.AcceptanceLocked === true
                            ? _c(
                                "button",
                                {
                                  staticClass:
                                    "btn btn-outline-secondary btn-sm",
                                  attrs: { title: "Unlock acceptance" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.handleUnlockProjectScenarioAcceptanceCommand(
                                        a.Id
                                      )
                                    },
                                  },
                                },
                                [_c("i", { staticClass: "fa-solid fa-lock" })]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          a.AcceptanceLocked === false
                            ? _c(
                                "button",
                                {
                                  staticClass:
                                    "btn btn-outline-secondary btn-sm",
                                  attrs: {
                                    title: "Lock acceptance",
                                    disabled: a.Acceptance === "TBD",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.handleLockProjectScenarioAcceptanceCommand(
                                        a.Id
                                      )
                                    },
                                  },
                                },
                                [
                                  _c("i", {
                                    staticClass: "fa-solid fa-lock-open",
                                  }),
                                ]
                              )
                            : _vm._e(),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "td",
                        { staticClass: "text-center align-middle" },
                        [
                          a.CommitmentDateLocked === true
                            ? [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(a.CommitmentDate ?? "Not set") +
                                    "\n                        "
                                ),
                              ]
                            : _vm._e(),
                          _vm._v(" "),
                          a.CommitmentDateLocked === false
                            ? [
                                _c(
                                  "a",
                                  {
                                    staticClass: "text-primary",
                                    on: {
                                      click: function ($event) {
                                        return _vm.showCommitmentDateMonthPicker(
                                          a
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(a.CommitmentDate ?? "Not set") +
                                        "\n                            "
                                    ),
                                  ]
                                ),
                              ]
                            : _vm._e(),
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c(
                        "td",
                        {
                          staticClass: "text-center align-middle",
                          staticStyle: { width: "40px" },
                        },
                        [
                          a.CommitmentDateLocked === true
                            ? _c(
                                "button",
                                {
                                  staticClass:
                                    "btn btn-outline-secondary btn-sm",
                                  attrs: { title: "Unlock commitment date" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.handleUnlockProjectScenarioCommitmentDateCommand(
                                        a.Id
                                      )
                                    },
                                  },
                                },
                                [_c("i", { staticClass: "fa-solid fa-lock" })]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          a.CommitmentDateLocked === false
                            ? _c(
                                "button",
                                {
                                  staticClass:
                                    "btn btn-outline-secondary btn-sm",
                                  attrs: { title: "Lock commitment date" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.handleLockProjectScenarioCommitmentDateCommand(
                                        a.Id
                                      )
                                    },
                                  },
                                },
                                [
                                  _c("i", {
                                    staticClass: "fa-solid fa-lock-open",
                                  }),
                                ]
                              )
                            : _vm._e(),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "td",
                        { staticClass: "text-center align-middle" },
                        [
                          a.StartDateLocked === true
                            ? [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(a.StartDate) +
                                    "\n                        "
                                ),
                              ]
                            : _vm._e(),
                          _vm._v(" "),
                          a.StartDateLocked === false
                            ? [
                                a.StartDate
                                  ? _c(
                                      "a",
                                      {
                                        staticClass: "text-primary",
                                        on: {
                                          click: function ($event) {
                                            return _vm.showStartDateMonthPicker(
                                              a
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                                " +
                                            _vm._s(a.StartDate) +
                                            "\n                            "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                !a.StartDate
                                  ? _c(
                                      "a",
                                      {
                                        staticClass: "text-muted pointer",
                                        attrs: {
                                          title: "Not set - default value",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.showStartDateMonthPicker(
                                              a
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                                Not set\n                            "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ]
                            : _vm._e(),
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c(
                        "td",
                        {
                          staticClass: "text-center align-middle",
                          staticStyle: { width: "40px" },
                        },
                        [
                          a.StartDateLocked === true
                            ? _c(
                                "button",
                                {
                                  staticClass:
                                    "btn btn-outline-secondary btn-sm",
                                  attrs: { title: "Unlock start date" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.handleUnlockProjectScenarioStartDateCommand(
                                        a.Id
                                      )
                                    },
                                  },
                                },
                                [_c("i", { staticClass: "fa-solid fa-lock" })]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          a.StartDateLocked === false
                            ? _c(
                                "button",
                                {
                                  staticClass:
                                    "btn btn-outline-secondary btn-sm",
                                  attrs: {
                                    title: "Lock start date",
                                    disable: !a.StartDate,
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.handleLockProjectScenarioStartDateCommand(
                                        a.Id
                                      )
                                    },
                                  },
                                },
                                [
                                  _c("i", {
                                    staticClass: "fa-solid fa-lock-open",
                                  }),
                                ]
                              )
                            : _vm._e(),
                        ]
                      ),
                      _vm._v(" "),
                      _c("td", { staticClass: "text-center align-middle" }, [
                        _c(
                          "a",
                          {
                            staticClass: "text-primary",
                            on: {
                              click: function ($event) {
                                return _vm.showMinStartDateMonthPicker(a)
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n                            " +
                                _vm._s(a.MinStartDate ?? "Not set") +
                                "\n                        "
                            ),
                          ]
                        ),
                      ]),
                      _vm._v(" "),
                      _c("td", { staticClass: "text-center align-middle" }, [
                        _c(
                          "a",
                          {
                            staticClass: "text-primary",
                            on: {
                              click: function ($event) {
                                return _vm.showMaxStartDateMonthPicker(a)
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n                            " +
                                _vm._s(a.MaxStartDate ?? "Not set") +
                                "\n                        "
                            ),
                          ]
                        ),
                      ]),
                    ])
                  }),
                  0
                ),
              ]),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c("br"),
      _vm._v(" "),
      _c("br"),
      _vm._v(" "),
      _c("br"),
      _vm._v(" "),
      _c("br"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }